// extracted by mini-css-extract-plugin
export default {"percent_text":"TrendsChart_percent_text__-pMIp","color_bar":"TrendsChart_color_bar__XdVo5"};